import React, { useMemo, useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { Button, Transfer, Modal, Bubble } from 'tea-component';
import Loading from '@/pages/intelligence/components/Loading';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import { getCountryFlag } from '@/pages/home/_config/countries';
import KeywordsSelect from './components/KeywordSelect';
import SourceTable from './components/SourceTable';
import TargetTable from './components/TargetTable';
import { getEntitiesKeys } from './utils';
import { getCountryCodeByCountryName } from '@/pages/intelligence/utils/commonUtils';
import { getDetailGameOverviewPath } from '@/pages/intelligence/utils/topchartsUtils';

import type { IEntity, IAddEntitiesProps } from './types';

import './index.scss';
import TipContext from '@/pages/home/components/TipContext';

export default function AddEntities(props: IAddEntitiesProps) {
  const { formatMessage } = useIntl();

  const {
    entityKey,
    title = formatMessage({ id: 'dbi_compare_add_game_to_compare' }),
    leftCellTitle = formatMessage({ id: 'dbi_compare_similar_games' }),
    rightCellTitle = formatMessage({ id: 'dbi_games' }),
    searchPlaceholder = formatMessage({ id: 'dbi_search_any_game' }),
    noSearchResultTips = formatMessage({ id: 'dbi_no_search_results' }),
    pleaseSelectTips = formatMessage({ id: 'dbi_please_a_select_game' }),
    notSelectTips = (
      <>
        {formatMessage({ id: 'dbi_compare_not_select_game_yet' })}
        <br />
        {formatMessage({ id: 'dbi_compare_please_search_game' })}
      </>
    ),

    // max = 6,
    // limitMsg = formatMessage(
    //   { id: 'dbi_compare_select_games_limit_tips' },
    //   { max: max || 6 },
    // ),
    entities,
    visible,
    entityRenderer: entityRendererOutter,
    onConfirm,
    onClose,

    keywordsFetcher,
    similarEntitiesFetcher,
    entitiesFetcher,
    tipText,
    entityType,
    followedGameList = [],
    followedGameIdList: followedKeyList = [],
    regionsCountries,
    getSearchNewList,
  } = props;

  // console.log('AddEntities', props);

  // const followedKeyList = useMemo(() => {
  //   if (Array.isArray(followedGameList) && followedGameList?.length > 0) {
  //     return followedGameList?.map((item: any) => item.gameId);
  //   } else {
  //     return [];
  //   }
  // }, [followedGameList]);

  function DefaultEntityRenderer(item: any) {
    return (
      <FirstRow
        cvm={item?.cvm}
        ifNeedFirstRowBubble={followedKeyList?.includes(item?.cvm?.gameId)}
        firstRowBubbleContent={formatMessage({ id: 'dbi_unfollow_goto_manage' })}
        rihgtClickToJumpHref={getDetailGameOverviewPath(item?.cvm?.gameId, entityType)}
      />
    );
  }

  const entityRenderer =
    typeof entityRendererOutter === 'function' ? entityRendererOutter : DefaultEntityRenderer;

  const entityRendererWithKeyword = (tablePayload: any) => entityRenderer(tablePayload, keyword);

  const [isLoading, setIsLoading] = useState(false);
  // 实体搜索关键字，这个关键字不是用户直接输入的，而是根据用户输入的关键字 在后台查询后 用户再次点击选择的关键字（用来搜索游戏 匹配概率更高？）
  const [keyword, setKeyword] = useState('');
  // 实体搜索关键字change
  const handleKeywordChange = async (payload: string) => {
    setKeyword(payload);
    if (!payload?.trim()) return;
    try {
      setIsLoading(true);
      if (entityType === 'company') {
        let entitiesTemp = await getSearchNewList?.({
          entity_type: 'company',
          keyword: payload,
          ids: [],
          system_type: 'pc',
          page: 1,
          page_size: 20,
          is_following: true,
        });

        entitiesTemp = Array.isArray(entitiesTemp?.list) ? entitiesTemp?.list : [];
        const list = entitiesTemp?.map((item) => ({
          gameId: item.game_id,
          gametitle: item.entity_name,
          text: item.publisher,
          img: item.cover,
          countryIcon: item.location_identifiers_country
            ? getCountryFlag(item.location_identifiers_country)
            : '',
        }));
        setSearchEntities(list);
      } else {
        let entitiesTemp = await entitiesFetcher?.({
          entity_type: entityType,
          keyword: payload,
          system_type: 'pc',
        });
        entitiesTemp = Array.isArray(entitiesTemp) ? entitiesTemp : [];

        const list = entitiesTemp?.map((item) => ({
          gameId: item.game_id,
          gametitle: item.entity_name,
          text: item.publisher,
          img: item.cover,
          countryIcon: item.location_identifiers_country
            ? getCountryFlag(item.location_identifiers_country)
            : '',
        }));
        setSearchEntities(list);
      }
    } catch (exception) {
    } finally {
      setIsLoading(false);
    }
  };

  // similar实体数据
  const [similarEntities, setSimilarEntities] = useState<IEntity[]>([]);
  // 搜索出来的实体数据
  const [searchEntities, setSearchEntities] = useState<IEntity[]>([]);

  // const selectedGroupsList = useMemo(() => {
  //   const leftListAll = [...searchEntities, ...similarEntities];
  //   const followedGameListTemp: any = followedGameList;
  //   let arrTemp = [];
  //   for (let n in followedGameListTemp) {
  //     if (leftListAll.findIndex((item: any) => item.app_id == followedGameListTemp[n].gameId) > -1) {
  //       arrTemp.push(followedGameListTemp[n]);
  //     }
  //   }
  //   return arrTemp;
  // }, [followedGameList, searchEntities, similarEntities]);

  // 勾选的实体数据
  const [checkedEntities, setCheckedEntities] = useState<IEntity[]>([]);
  // 勾选的实体数据的keys
  const checkedEntitiesKeys = useMemo<string[]>(
    () => getEntitiesKeys(checkedEntities, entityKey),
    [entityKey, checkedEntities],
  );
  const handleCheckedEntitiesKeysChange = (payload: string[]) => {
    // console.log('handleCheckedEntitiesKeysChange', payload);
    const checkedEntitiesTemp: IEntity[] = [];
    const similarEntitiesKeysMap: {
      [key: string]: boolean;
    } = {};
    const similarEntitiesAndSearchEntitiesTemp = [
      ...checkedEntities,
      ...similarEntities,
      ...searchEntities,
    ];
    for (const entity of similarEntitiesAndSearchEntitiesTemp) {
      const entityKeyTemp = entity?.[entityKey];
      if (!payload?.includes(entityKeyTemp)) continue;
      if (similarEntitiesKeysMap[entityKeyTemp]) continue;
      checkedEntitiesTemp?.unshift(entity);
      similarEntitiesKeysMap[entityKeyTemp] = true;
    }
    const dataList = checkedEntitiesTemp?.filter(
      (item: any) => !(followedKeyList?.findIndex((itemSub: any) => itemSub == item.gameId) > -1),
    );
    setCheckedEntities(dataList);
  };

  // const isDisabledGames = useMemo<boolean>(
  //   () => checkedEntitiesKeys?.length >= max,
  //   [checkedEntitiesKeys?.length, max],
  // );

  const handleRemoveCheckedEntity = (payload: string) => {
    const checkedEntitiesTemp: IEntity[] =
      checkedEntities?.filter((item) => item?.[entityKey] !== payload) || [];
    setCheckedEntities(checkedEntitiesTemp);
  };

  const handleClearAll = () => {
    setCheckedEntities([]);
  };

  const handleConfirm = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    // following的AddEntities-onConfirm只需要一个参数key
    onConfirm?.([...followedKeyList, ...checkedEntitiesKeys]);
  };

  const handleCancel = (e?: React.MouseEvent<Element, MouseEvent>) => {
    e?.stopPropagation();
    e?.preventDefault();
    onClose?.();
  };

  const initData = async () => {
    // if (!Array.isArray(entities)) return;
    setIsLoading(true);
    // setCheckedEntities(entities);
    try {
      const gameType = entities?.game_type || '';
      const gameTypeValue = gameType?.replace(/['']{1,2}/g, '');

      const entitiesParams = {
        ...entities,
        game_type: gameTypeValue,
      };

      const similarEntitiesTemp = await similarEntitiesFetcher?.(entitiesParams);
      if (entityType === 'company') {
        const companyData = Array.isArray(similarEntitiesTemp?.company_data)
          ? similarEntitiesTemp?.company_data
          : [];
        const list = companyData?.map((item) => ({
          gameId: item.app_id,
          gametitle: item.name,
          text: `${item.location_identifiers_city} ${item.location_identifiers_country}`,
          img: item.image_url,
          countryIcon: getCountryFlag(
            item?.publisher_addr || item?.location_identifiers_country_code,
          ),
        }));
        setSimilarEntities(list);
      } else {
        const gameData = Array.isArray(similarEntitiesTemp?.GameData)
          ? similarEntitiesTemp?.GameData
          : [];

        const list = gameData?.map((item) => ({
          gameId: item.app_id,
          gametitle: item.name,
          text: item.publisher,
          img: item.cover,
          countryIcon: getCountryFlag(item.publisher_addr),
        }));
        setSimilarEntities(list);
      }
    } catch (exception) {
      setSimilarEntities([]);
    } finally {
      setIsLoading(false);
    }
  };

  const resetData = () => {
    setKeyword('');
    setSearchEntities([]);
    setSimilarEntities([]);
    setCheckedEntities([]);
    setIsLoading(false);
  };

  useEffect(() => {
    if (visible) {
      initData();
    } else {
      resetData();
    }
  }, [visible]);

  const checkedEntitiesKeysLeft = useMemo(() => {
    return [...followedKeyList, ...checkedEntitiesKeys];
  }, [checkedEntitiesKeys, followedKeyList]);

  const checkedEntitiesCur = useMemo(() => {
    const followedGameListTemp: any = checkedEntities;
    for (const n in checkedEntities) {
      if (followedKeyList?.findIndex((item: any) => item == checkedEntities[n].gameId) > -1) {
        followedGameListTemp?.splice(n, 1);
      }
    }
    return followedGameListTemp;
  }, [checkedEntities]);

  const renderSearchedGames = () => {
    if (!searchEntities?.length)
      return (
        <div className="dbi-table-no-data dbi-left-cell">
          <div>
            <div style={{ textAlign: 'center' }}>{noSearchResultTips}</div>
            <div>
              {formatMessage(
                { id: 'dbi_type_games_only' },
                { type: formatMessage({ id: `dbi_${entityType}_games` }) },
              )}
            </div>
          </div>
        </div>
      );
    return (
      <SourceTable
        title={leftCellTitle}
        isDisabledGames={followedKeyList}
        // isDisabled={followedKeyList}
        disabledMsg={formatMessage({ id: 'dbi_unfollow_goto_manage' })}
        hideHeader={true}
        entityKey={entityKey}
        records={searchEntities}
        value={checkedEntitiesKeysLeft}
        onChange={handleCheckedEntitiesKeysChange}
        entityRenderer={entityRendererWithKeyword}
      />
    );
  };

  const renderSimilarGames = () => {
    if (!similarEntities?.length)
      return <div className="dbi-table-no-data dbi-left-cell">{notSelectTips}</div>;
    return (
      <SourceTable
        title={leftCellTitle}
        isDisabledGames={followedKeyList}
        // isDisabled={followedKeyList}
        disabledMsg={formatMessage({ id: 'dbi_unfollow_goto_manage' })}
        entityKey={entityKey}
        records={similarEntities}
        value={checkedEntitiesKeysLeft}
        onChange={handleCheckedEntitiesKeysChange}
        entityRenderer={entityRenderer}
      />
    );
  };

  const renderLeftCell = () => {
    if (isLoading) return <Loading />;
    if (keyword) return renderSearchedGames();
    return renderSimilarGames();
  };

  const renderRightCell = () => (
    <TargetTable
      className={classnames({ 'is-no-data': !checkedEntitiesCur?.length })}
      title={rightCellTitle}
      pleaseSelectTips={pleaseSelectTips}
      entityKey={entityKey}
      records={checkedEntitiesCur}
      onRemove={handleRemoveCheckedEntity}
      entityRenderer={entityRenderer}
    />
  );

  // useEffect(()=> {
  //   if(followedGameList){
  //     setCheckedEntities(followedGameList);
  //   }
  // }, [followedGameList, visible])

  const isDisabled = useMemo(() => {
    return !checkedEntitiesKeys?.length;
  }, [checkedEntitiesKeys]);

  return (
    <Modal
      className="dbi-add-entities-modal dbi-add-entities-follow"
      visible={visible}
      caption={
        <div className="dbi-add-title">
          {title}
          {tipText && <TipContext className="dbi-add-title-icon" tipText={tipText} />}
        </div>
      }
      size={800}
      onClose={() => onClose?.()}
    >
      <Modal.Body>
        <Transfer
          // selection-centered 组件库使用的 公共样式
          className="dbi-add-games-compare selection-centered"
          leftCell={
            <Transfer.Cell
              scrollable={false}
              title={formatMessage({ id: 'dbi_game_add' })}
              header={
                <KeywordsSelect
                  searchPlaceholder={searchPlaceholder}
                  keywordsFetcher={keywordsFetcher}
                  value={keyword}
                  entityType={entityType}
                  onChange={handleKeywordChange}
                />
              }
            >
              {renderLeftCell()}
            </Transfer.Cell>
          }
          rightCell={
            <Transfer.Cell
              className="dbi-compare-right"
              scrollable={false}
              title={
                <div className="compare-title-flex">
                  <div className="compare-title">
                    {formatMessage({ id: 'dbi_compare_selected' })} ({checkedEntitiesKeys?.length})
                  </div>
                  {checkedEntities?.length > 0 && (
                    <Button type="link" className="compare-btn" onClick={handleClearAll}>
                      {formatMessage({ id: 'dbi_compare_clear_all' })}
                    </Button>
                  )}
                </div>
              }
            >
              {renderRightCell()}
            </Transfer.Cell>
          }
        />
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={handleConfirm} disabled={isDisabled}>
          {formatMessage({ id: 'dbi_confirm' })}
        </Button>
        <Button type="weak" onClick={handleCancel}>
          {formatMessage({ id: 'dbi_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export type { IAddEntitiesProps };
